// import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   selectedProductId: null, // Store only one selected product ID
// };

// const allSpecialProductsId = createSlice({
//   name: 'allSpecialProductsId',
//   initialState,
//   reducers: {
//     setSpecialProductsId: (state, action) => {
//       state.selectedProductId = action.payload; // Store the selected product ID
//     },
//   },
// });

// export const { setSpecialProductsId } = allSpecialProductsId.actions;
// export default allSpecialProductsId.reducer;

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedProductId: null, // Store only one selected product ID
  forecastUrl: null, // Store the generated forecast URL
};

const allSpecialProductsId = createSlice({
  name: 'allSpecialProductsId',
  initialState,
  reducers: {
    setSpecialProductsId: (state, action) => {
      state.selectedProductId = action.payload; // Store the selected product ID
    },
    setForecastUrl: (state, action) => {
      state.forecastUrl = action.payload; // Store the generated forecast URL
    },
  },
});

export const { setSpecialProductsId, setForecastUrl } =
  allSpecialProductsId.actions;
export default allSpecialProductsId.reducer;
